 const versionData = {
    version:"3.0.0",
    date:"14/02/2024"
 };
 export default versionData